import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs';
import { ProductModel } from '../../core/rest/products/model/product.model';

@Injectable()
export class CheckoutTotalAmountService {
  private productsSubject = new BehaviorSubject<ProductModel[]>([]);
  products$ = this.productsSubject.asObservable();

  get totalAmount$(): Observable<number> {
    return this.products$
      .pipe(
        map(products => {
          if (!products?.length) {
            return 0;
          }
          const totalMinor = products.reduce(
            (sum, product) => sum + this.toMinor(product.price) * this.normalizeQuantity(product.quantity),
            0
          );
          return totalMinor / 100;
        }),
        distinctUntilChanged(),
      )
  }

  updateProducts(products: ProductModel[]): void {
    this.productsSubject.next([...products]);
  }

  decreaseProductQuantity(product: ProductModel) {
    this.updateProductQuantity(product, product.quantity - 1);
  }

  increaseProductQuantity(product: ProductModel) {
    this.updateProductQuantity(product, product.quantity + 1);
  }

  updateProductQuantity(product: ProductModel, quantity: number) {
    const updatedProducts = this.productsSubject.value
      .map((p) =>
      p.id === product.id ? {...p, quantity: this.normalizeQuantity(quantity)} : p
    );
    this.productsSubject.next(updatedProducts);
  }

  private toMinor(amount: number): number {
    return Math.round((Number(amount) + Number.EPSILON) * 100);
  }

  private normalizeQuantity(quantity: number): number {
    const value = Number(quantity);
    if (!Number.isFinite(value)) {
      return 0;
    }
    return Math.min(99, Math.max(0, Math.trunc(value)));
  }
}
